import "./index.css";
import MapIconActive from "assets/images/map-icon.svg";
import MapIconGuide from "assets/images/map-icon-guide.svg";
import TextLogo from "assets/images/text-logo.png";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { Drawer, List } from "@material-ui/core";
import { SYSTEM_MANAGEMENT } from "./constants";
import { memo, useEffect, useState } from "react";
import useWindowSize from "app/shared/hooks/useWindowSizes";
import { useLocation } from "react-router-dom";
import workspaceApi from "app/api/workspaceApi";
import { connect, useDispatch, useSelector } from "react-redux";
import { shallowEqual } from "react-intl/src/utils";
import OrganizationIcon from "assets/images/organization-icon.svg";
import ActiveOrganizationIcon from "assets/images/active-organization-icon.svg";
import UserIcon from "assets/images/user-icon.svg";
import ActiveUserIcon from "assets/images/active-user-icon.svg";
import WorkspaceIcon from "assets/images/workspace-icon.svg";
import ActiveWorkspaceIcon from "assets/images/active-workspace-icon.svg";
import StationTypesIcon from "assets/images/station-types-icon.svg";
import ActiveStationTypesIcon from "assets/images/active-station-types-icon.svg";
// import BellIcon from "assets/images/bell.svg";
// import ActiveBellIcon from "assets/images/active-bell.svg";
import Alert from "assets/images/alert.svg";
import ActiveAlert from "assets/images/active-alert.svg";
import Setting from "assets/images/setting.svg";
import SettingActive from "assets/images/setting-active.svg";
// import Camera from "assets/images/camera.svg";
// import CameraActive from "assets/images/camera-active.svg";
import Legend from "assets/images/legend.svg";
import LegendActive from "assets/images/legend-active.svg";
import ExportDataStation from "assets/images/exportdata.svg";
import ExportDataStationActive from "assets/images/exportdata-active.svg";
import { injectIntl } from "react-intl";
import { useLanguage } from "app/shared/hooks";
import SidebarItem from "./SidebarItem";
import WorkspaceSidebarItem from "./WorkspaceSidebarItem";
import { triggerSidebar } from "app/redux/actions/sidebar.action";

const Sidebar = (props) => {
  const { active, setActive, intl } = props;
  const [hoverActive, setHoverActive] = useState(false);
  const [workspaces, setWorkpaces] = useState([]);
  const location = useLocation();
  const size = useWindowSize();
  const [language] = useLanguage();
  const [allWorkspaces, setAllWorkspaces] = useState([]);
  const { token, reloadData, role, user } = useSelector(
    ({ user }) => ({
      token: user.token,
      role: user.role,
      user: user.user,
      reloadData: user.reloadData,
    }),
    shallowEqual,
  );
  const { dashboard: dashboardState } = useSelector(
    ({ dashboard }) => ({
      dashboard,
    }),
    shallowEqual,
  );
  const { openSidebar } = useSelector((state) => state?.sidebar, shallowEqual);
  const mapboxInstance = useSelector(
    ({ maps }) => maps?.mapboxInstance,
    shallowEqual,
  );
  const dispatch = useDispatch();

  const IS_OWNER_OR_ADMIN = role?.id === 1 || role?.id === 3;
  const roles =
    role.permission_sys &&
    role.permission_sys.length &&
    role.permission_sys.filter((item) => item.view).map((item) => item.code);
  const addNewRoles =
    role.permission_sys &&
    role.permission_sys.length &&
    role.permission_sys.filter((item) => item.new).map((item) => item.code);
  const editRoles =
    role.permission_sys &&
    role.permission_sys.length &&
    role.permission_sys.filter((item) => item.edit).map((item) => item.code);
  const deleteRoles =
    role.permission_sys &&
    role.permission_sys.length &&
    role.permission_sys.filter((item) => item.delete).map((item) => item.code);

  const fetchWorkSpaces = async (options) => {
    try {
      const params = {
        amount: 50,
        arrangement: "DESC",
        order: "createdAt",
      };
      const res = await workspaceApi.getAllworkspaces(params, token);

      const newData = [
        {
          id: 9,
          icon: MapIconGuide,
          activeIcon: MapIconActive,
          name: intl.formatMessage({ id: "CLIENT.GENERAL.MENU_MAPS" }),
          link: "/monitoring-map",
          code: "workspaces",
          key: "parent",
          enabled: true,
          subs: [],
          showsLeftArrow: false,
        },
        {
          id: 1,
          icon: OrganizationIcon,
          activeIcon: ActiveOrganizationIcon,
          name: intl.formatMessage({
            id: "CLIENT.ORGANIZATION_MANAGEMENT.PAGE_TITLE",
          }),
          link: "/organizations",
          subs: [],
          code: "organizations",
          key: "parent",
          enabled: true,
        },
        {
          id: 2,
          icon: UserIcon,
          activeIcon: ActiveUserIcon,
          name: intl.formatMessage({
            id: "CLIENT.ACCOUNT_MANAGEMENT.PAGE_TITLE",
          }),
          key: "parent",
          enabled: true,
          link: "",
          subs: [
            {
              id: 1,
              icon: UserIcon,
              activeIcon: ActiveUserIcon,
              name: intl.formatMessage({ id: "CLIENT.GENERAL.ACCOUNTS" }),
              link: "/account",
              key: "children",
              code: "account",
              subs: [],
            },
            // {
            //   id: 2,
            //   icon: LockIcon,
            //   activeIcon: ActiveLockIcon,
            //   name: intl.formatMessage({
            //     id: "CLIENT.ROLE_MANAGEMENT.PAGE_TITLE",
            //   }),
            //   link: "/roles",
            //   key: "children",
            //   code: "roles",
            //   subs: [],
            // },
          ].filter(
            (item) =>
              !item.code ||
              (roles && roles.length && roles.indexOf(item.code) !== -1),
          ),
        },
        {
          id: 3,
          icon: WorkspaceIcon,
          activeIcon: ActiveWorkspaceIcon,
          name: intl.formatMessage({ id: "CLIENT.GENERAL.WORKSPACES" }),
          link: "/workspaces",
          key: "parent",
          code: "workspaces",
          actionType: "workspaces",
          canAddNew: addNewRoles?.indexOf("workspaces") !== -1,
          enabled: true,
          subs: res.data
            .map((item) => ({
              id: item.id,
              icon: WorkspaceIcon,
              activeIcon: ActiveWorkspaceIcon,
              name: language === "en" ? item.name : item.name_vi,
              link: `/workspaces/edit/${item.id}?tab=0`,
              key: "children",
              code: "workspaces",
              actionType: "workspaces-children",
              canAddNew: addNewRoles?.indexOf("stations") !== -1,
              canEdit: editRoles?.indexOf("workspaces") !== -1,
              canDelete: deleteRoles?.indexOf("workspaces") !== -1,
              canAddNewDashBoard: addNewRoles?.indexOf("workspaces") !== -1,
              dashboards:
                item.workspace_dashboard &&
                item.workspace_dashboard &&
                item.workspace_dashboard.map((elm) => ({
                  id: elm.id,
                  name: elm[`name_${language}`],
                  iconType: "dashboard",
                  link: `/workspaces/${item.id}/dashboards/${elm.id}`,
                  key: "sub-sub-children",
                  actionType: "dashboard",
                  code: "workspaces",
                  workspaceId: item.id, // important,
                  renameNavId: options?.renameNavId,
                  isView:
                    elm?.workspace_dashboard_security
                      ?.workspace_dashboard_permission_id === 1,
                  subs: [],
                  canEdit: editRoles?.indexOf("workspaces") !== -1,
                  canDelete: deleteRoles?.indexOf("workspaces") !== -1,
                })),
              subs:
                item.station &&
                item.station.length &&
                item.station.map((elm) => ({
                  id: elm.id,
                  disableMoveDelete: elm.create_by !== user?.id,
                  name: language === "en" ? elm.name : elm.name_vi,
                  iconType: "station",
                  link: `/station/edit/${elm.id}?tab=0`,
                  actionType: "station",
                  key: "sub-sub-children",
                  code: "stations",
                  workspaceId: item.id,
                  subs: [],
                  canEdit: editRoles?.indexOf("stations") !== -1,
                  canDelete: deleteRoles?.indexOf("stations") !== -1,
                })),
              // maps: [],
            }))
            .filter(
              (item) =>
                !item.code ||
                (roles && roles.length && roles.indexOf(item.code) !== -1),
            ),
        },
        {
          id: 4,
          icon: ExportDataStation,
          activeIcon: ExportDataStationActive,
          name: intl.formatMessage({ id: "CLIENT.GENERAL.EXPORT_DATA_STATION" }),
          link: "/export-data-station",
          key: "parent",
          enabled: true,
          subs: [],
          showsLeftArrow: false,
        },
        {
          id: 5,
          icon: StationTypesIcon,
          activeIcon: ActiveStationTypesIcon,
          name: intl.formatMessage({
            id: "CLIENT.STATION_TYPES_MANAGEMENT.PAGE_TITLE",
          }),
          link: "/station-types",
          key: "parent",
          code: "station_types",
          activeLinks: [
            "/station-types",
            "/station-types/add",
            "/station-types/edit",
          ],
          subs: [],
          enabled: true,
        },
        {
          id: 10,
          icon: Setting,
          activeIcon: SettingActive,
          name: intl.formatMessage({ id: "CLIENT.GENERAL.UNDP" }),
          link: "",
          key: "parent",
          code: "chats",
          enabled: true,
          subs: [
            // {
            //   id: 1,
            //   icon: BellIcon,
            //   activeIcon: ActiveBellIcon,
            //   name: intl.formatMessage({
            //     id: "CLIENT.GENERAL.UNDP.ZALO",
            //   }),
            //   link: "/undp-zalo",
            //   key: "children",
            //   code: "chats",
            //   subs: [],
            // },
            // {
            //   id: 2,
            //   icon: Camera,
            //   activeIcon: CameraActive,
            //   name: intl.formatMessage({
            //     id: "CLIENT.GENERAL.UNDP.CAMERA",
            //   }),
            //   link: "/undp-camera",
            //   key: "children",
            //   code: "chats",
            //   subs: [],
            // },
            // {
            //   id: 3,
            //   icon: Legend,
            //   activeIcon: LegendActive,
            //   name: intl.formatMessage({
            //     id: "CLIENT.GENERAL.UNDP.LEGEND",
            //   }),
            //   link: "/legend",
            //   key: "children",
            //   code: "chats",
            //   subs: [],
            // },
            {
              id: 4,
              icon: Alert,
              activeIcon: ActiveAlert,
              name: intl.formatMessage({
                id: "CLIENT.GENERAL.UNDP.ALERT",
              }),
              link: "/alert",
              key: "children",
              code: "chats",
              subs: [],
            },
          ]
        }
      ].filter((item) => {
        if (user?.email === "guest@example.com" && item.id === 10) {
          return false;
        }
        return (
          (!item.code ||
            (roles && roles.length && roles.indexOf(item.code) !== -1)) &&
          !process.env.REACT_APP_HIDDEN_ITEM_ID?.split(",").includes(
            item.id.toString()
          ) &&
          item.enabled
        );
      });

      setAllWorkspaces(
        res.data.map((item) => ({
          id: item.id,
          value: item.id,
          label: language === "en" ? item.name : item.name_vi,
        })),
      );
      setWorkpaces(newData);
    } catch (error) {
      const newData = [
        ...SYSTEM_MANAGEMENT,
        {
          id: 3,
          icon: WorkspaceIcon,
          activeIcon: ActiveWorkspaceIcon,
          name: "Workspace Management",
          key: "workspace-management",
          link: "",
          subs: [
            {
              id: 0,
              icon: WorkspaceIcon,
              activeIcon: ActiveWorkspaceIcon,
              name: "Workspace",
              link: "/workspaces",
              key: "workspace-management-children",
              code: "workspaces",
              subs: [],
            },
            {
              id: 1,
              icon: WorkspaceIcon,
              activeIcon: ActiveWorkspaceIcon,
              name: "Workspace Details",
              link: "",
              key: "workspace-management-children",
              code: "workspaces",
              subs: [],
            },
            {
              id: 3,
              icon: StationTypesIcon,
              activeIcon: ActiveStationTypesIcon,
              name: "Station Types",
              link: "/station-types",
              key: "workspace-management-children",
              code: "station_types",
              subs: [],
            },
          ],
        }
      ];
      setWorkpaces(newData);
    }
  };

  useEffect(() => {
    fetchWorkSpaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData, dashboardState.name]);

  const handleMouseEnter = () => {
    if (!hoverActive && !active) {
      setHoverActive(true);
    }
  };

  const handleMouseLeave = () => {
    if (hoverActive && !active) {
      setHoverActive(false);
    }
  };

  const toggleDrawer = () => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    dispatch(triggerSidebar());
  };

  const handleToggle = () => {
    setActive(!active);
    localStorage.setItem("active_nav", !active);

    let mapContentWidth = "calc(100vw - ";

    if (active) {
      document.getElementById("main-layout").style.paddingLeft = "70px";
      mapContentWidth += "30px)";
    } else {
      document.getElementById("main-layout").style.paddingLeft = "286px";
      mapContentWidth += "243px)";
    }

    const mapContent = document.getElementById("mapbox__content");
    if (mapContent) {
      mapContent.style.width = mapContentWidth;
      mapboxInstance?.resize();
    }
  };
  const renderNavs = (items, key = "") => {
    let currentPath = `/${location.pathname.split("/")[1]}`;

    if (currentPath?.startsWith("/v2")) {
      currentPath = `/v2/${location.pathname.split("/")[2]}`;
    }

    return items.map((item) => {
      return (item.code === "workspaces" ||
        item.code === "stations" ||
        item.code === "maps" ||
        item.code === "userGuides" ||
        item.code === "content") &&
        item.link ? (
        <div key={item.id}>
          <WorkspaceSidebarItem
            itemKey={item.key}
            id={item.id}
            link={item.link}
            currentPath={currentPath}
            renderKey={item.code === "content" ? item.code : key}
            activeIcon={item.activeIcon}
            icon={item.icon}
            name={item.name}
            subs={item.subs}
            dashboards={item.dashboards}
            workspaces={workspaces}
            renderNavs={renderNavs}
            iconType={item.iconType}
            actionType={item.actionType}
            reloadData={fetchWorkSpaces}
            token={token}
            workspaceId={item.workspaceId || item.id}
            active={active}
            isView={item.isView}
            canAddNew={item.canAddNew}
            renameNavId={item.renameNavId}
            renameMapId={item.renameMapId}
            maps={[]}
            sourceData={items}
            setWorkpaces={setWorkpaces}
            userGuides={item.userGuides}
            order={item?.order}
            categoryList={item?.categoryList}
            allWorkspaces={allWorkspaces}
            canEdit={item.canEdit}
            canDelete={item.canDelete}
            canAddNewDashBoard={item.canAddNewDashBoard}
            disableMoveDelete={item?.disableMoveDelete}
            showsLeftArrow={item?.showsLeftArrow}
          />
        </div>
      ) : (
        <div key={item.id}>
          <SidebarItem
            itemKey={item.key}
            id={item.id}
            link={item.link}
            currentPath={currentPath}
            renderKey={key}
            activeIcon={item.activeIcon}
            icon={item.icon}
            name={item.name}
            subs={item.subs}
            workspaces={workspaces}
            renderNavs={renderNavs}
            iconType={item.iconType}
            active={active}
            allWorkspaces={allWorkspaces}
          />
        </div>
      );
    });
  };

  return (
    <>
      <div className="sidebar desktop-sidebar">
        <div
          className={`wrapper ${!active && !hoverActive ? "inactive-wrapper" : ""}`}
        >
          <div className="inner">
            <div className="header">
              <div className="logo organization-name">
                {props.name ? (
                  language === "en" ? (
                    props.name
                  ) : (
                    props.nameVi
                  )
                ) : (
                  <img src={TextLogo} alt="logo" />
                )}
              </div>
              <div className="toggle" onClick={handleToggle}>
                <div className={`icon ${!active ? "inactive-icon" : ""}`}></div>
              </div>
            </div>
            <div
              className="content"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                  <p className="list-header">
                    {active || hoverActive ? (
                      intl.formatMessage({
                        id: "CLIENT.GENERAL.SYSTEM_MANAGEMENT",
                      })
                    ) : (
                      <MoreHorizIcon />
                    )}
                  </p>
                }
              >
                {renderNavs(workspaces)}
              </List>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        anchor="left"
        open={size.width >= 1000 ? false : openSidebar}
        onClose={toggleDrawer()}
      >
        <div className="sidebar mobile-sidebar">
          <div className="wrapper">
            <div className="inner">
              <div className="content">
                <List
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                  subheader={
                    <p className="list-header">
                      {active || hoverActive ? (
                        intl.formatMessage({
                          id: "CLIENT.GENERAL.SYSTEM_MANAGEMENT",
                        })
                      ) : (
                        <MoreHorizIcon />
                      )}
                    </p>
                  }
                >
                  {renderNavs(workspaces)}
                </List>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};
function mapStateToProps(state) {
  const { user } = state;
  return {
    name: (user.userOrganization && user.userOrganization.name) || null,
    nameVi: (user.userOrganization && user.userOrganization.nameVi) || null,
  };
}
export default memo(injectIntl(connect(mapStateToProps)(Sidebar)));
